// A pre-sale: a product sold before it is out (`presale`, `releaseDate`) ships
// once it is, promised by a few days after the release — the API's rule
// (aldoo-com-api commerce/lib/presale.js), which keeps what an order promised
// on its line (`line.presale`).
const DELIVERY_DAYS_AFTER_RELEASE = 3
const DAY = 86400000

/**
 * Whether a product is on pre-sale now: marked so and its release date still
 * ahead — on the release day it sells as the rest do (the API's rule too).
 */
export function isPresale(product, now = Date.now()) {
  if (!product?.presale || !product.releaseDate) return false
  const release = new Date(product.releaseDate).getTime()
  return Number.isFinite(release) && release > now
}

/** { releaseDate, deliverBy } (Dates) of a product on pre-sale now, else null. */
export function presaleOf(product) {
  if (!isPresale(product)) return null
  const release = new Date(product.releaseDate)
  return { releaseDate: release, deliverBy: new Date(release.getTime() + DELIVERY_DAYS_AFTER_RELEASE * DAY) }
}

/** An order line's promise, as checkout kept it (dates arrive as strings). */
export function linePresaleOf(line) {
  const presale = line?.presale
  if (!presale) return null
  const date = (value) => (value ? new Date(value) : null)
  return { releaseDate: date(presale.releaseDate), deliverBy: date(presale.deliverBy) }
}

/** A pre-sale date as the shop writes dates: 12.10.2026 (en: 12 Oct 2026). */
export const presaleDate = (date, locale) =>
  // in the shop's zone: the server (UTC) and the reader's browser must name the same day
  date ? date.toLocaleDateString(locale || undefined, { ...(locale === "bg" ? { day: "2-digit", month: "2-digit", year: "numeric" } : { day: "numeric", month: "short", year: "numeric" }), timeZone: "Europe/Sofia" }) : ""
